import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    filterProp: Object,
  },

  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      resolutionForecast: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Equipamento / Setor',
          align: 'center',
          value: 'equipment',
        },
        {
          text: 'Nº Chamado',
          align: 'center',
          value: 'serviceOrder',
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'unidade',
        },
        {
          text: 'Tempo Resolução',
          align: 'center',
          value: 'serviceTime',
        },
        {
          text: 'Limite Tempo Resolução Unidade',
          align: 'center',
          value: 'serviceTimeLimit',
        },
      ],
      mobileHeader: [
        {
          text: 'Equipamento',
          align: 'center',
          value: 'equipment',
        },
      ],
      total: 0,
    }
  },

  async created() {
    this.listResolutionForecast()
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `resolution_Forecast_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/resolutionForecast', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listResolutionForecast() {
      this.loading = true
      await this.apiService
        .post('reports/resolutionForecast', this.filterProp)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
          this.showChart = response.content.objects.length > 0
          this.resolutionForecast = response.content.objects
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },

  watch: {
    page() {
      this.filterProp.page = this.page
      this.listResolutionForecast()
    },
  },
}
